import { GET_FORWARDER_E_WALLET_BALANCE } from '../actions/actionTypes';

import ForwarderInvoiceBalance from '../../models/ForwarderGhaInvoiceBalance';

const initialState: ForwarderInvoiceBalance = { accountType: '', balance: 0 };

export default function walletFwdBalanceReducer(state: ForwarderInvoiceBalance = initialState, action: any): ForwarderInvoiceBalance {

  switch (action.type) {

    case GET_FORWARDER_E_WALLET_BALANCE:
      return {
        ...state,
        accountType: action.data.accountType,
        balance: action.data.balance
      }
    default:
      return state;
  }

};